import React, { useRef, useState, useEffect } from "react";
import { useReactToPrint } from 'react-to-print';
import { useLocation } from "react-router-dom";
import { generarReporteSocioeconomicoB_Jumio } from "../api/generarReporteSocioeconomicoB_Jumio";
import { generarImagenReporte } from "../api/generarImagenReporte";
import { jsPDF } from "jspdf";
import Modal from 'react-bootstrap/Modal';
import parse from 'html-react-parser';
import "./print.css";
import "./style.css";

const SocioEconomicoB_Jumio = () => {

  const componentRef = useRef(null);
  const isRunned = useRef(false);
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const [modalShow, setModalShow] = useState(false);
  const [show, setShow] = useState(false);
  const [showStatus, setShowStatus] = useState(null);
  const [showMessage, setShowMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [validateCurpCpv, setValidateCurpCpv] = useState(false);
  const [textGreen, setTextGreen] = useState("")
  const [textYellow, setTextYellow] = useState("")

  const [imagenFront, setImagenFront] = useState("");
  const [imagenBack, setImagenBack] = useState("");

  /*Variables Estudio Socioeconómico*/
  const [usuarioGrafica, setUsuarioGrafica] = useState("");
  const [usuarioNivelSocioeconomico, setUsuarioNivelSocioeconomico] = useState("");

  /*Areas Evaluadas*/
  const [usuarioIngresoGrafica, setusuarioIngresoGrafica] = useState("");
  const [usuarioIngreso, setusuarioIngreso] = useState("");
  const [usuarioEducacionGrafica, setusuarioEducacionGrafica] = useState("");
  const [usuarioEducacion, setusuarioEducacion] = useState("");
  const [usuarioDigitalizacionGrafica, setusuarioDigitalizacionGrafica] = useState("");
  const [usuarioDigitalizacion, setusuarioDigitalizacion] = useState("");
  const [usuarioViviendaGrafica, setusuarioViviendaGrafica] = useState("");
  const [usuarioVivienda, setusuarioVivienda] = useState("");
  const [usuarioUbicacionGrafica, setusuarioUbicacionGrafica] = useState("");
  const [usuarioUbicacion, setusuarioUbicacion] = useState("");
  const [usuarioMontoIngreso, setUsuarioMontoIngreso] = useState("");
  const [usuarioReferencias, setusuarioReferencias] = useState("");

  /*Footer */

  const [usuarioFooter, setUsuarioFooter] = useState("");
  const [cardSvgP, setCardSvgP] = useState("");
  const [logoDPR, setLogoDPR] = useState("");
  const [check_deepBlue, setCheck_deepBlue] = useState("");
  const [cardSvgBlack, setCardSvgBlack] = useState("");
  const [qr, setQr] = useState("");

  /*---Nombre reporte---*/

  const date = new Date();
  const formattedDate = date.toLocaleDateString('en-GB', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).split('/').reverse().join('-');
  const [cpv, setCpv] = useState(params.get("i"));

  /*-----------------------------------*/
  const [vigencia, setVigencia] = useState("");
  const [narrativa, setNarrativa] = useState("");
  const [telefonoCeluar, setTelefonoCeluar] = useState("");

  const [internetMovil, setInternetMovil] = useState("");
  const [television, setTelevision] = useState("");
  const [motocicleta, setMotocicleta] = useState("");
  const [internetFijo, setInternetFijo] = useState("");
  const [tabletaElectronica, setTabletaElectronica] = useState("");
  const [computadora, setComputadora] = useState("");
  const [vehiculo, setVehiculo] = useState("");
  const [telefonoInteligente, setTelefonoInteligente] = useState("");
  const [viviendaP, setViviendaP] = useState("");

  const [usuarioEstructuraFamiliarGrafica, setUsuarioEstructuraFamiliarGrafica] = useState("");
  const [usuarioPatrimonioDeclaradoGrafica, setUsuarioPatrimonioDeclaradoGrafica] = useState("");
  const [usuarioSonificacionViviendaGrafica, setUsuarioSonificacionViviendaGrafica] = useState("");
  const [estructuraFamiliar, setEstructuraFamiliar] = useState("");
  const [patrimonioDeclarado, setPatrimonioDeclarado] = useState("");
  const [sonificacionVivienda, setSonificacionVivienda] = useState("");
  const [ingresoG, setIngresoG] = useState("");
  const [educacionG, setEducacionG] = useState("");
  const [digitalizacionG, setDigitalizacionG] = useState("");
  const [viviendaG, setViviendaG] = useState("");
  const [ubicacionG, setUbicacionG] = useState("");
  const [tendencia, setTendencia] = useState("");
  const [ingresoArr, setIngresoArr] = useState([]);
  const [educacionArr, setEducacionArr] = useState([]);
  const [digitalizacionGArr, setDigitalizacionGArr] = useState([]);
  const [viviendaGArr, setViviendaGArr] = useState([]);
  const [ubicacionGArr, setUbicacionGArr] = useState([]);
  const [ingresoGrafica, setIngresoGrafica] = useState(0);
  const [educacionGrafica, setEducacionGrafica] = useState(0);

  const valorCicloAreas = 7;

  const handleClose = () => {
    setShow(false);
  }


  useEffect(() => {

    if (isRunned.current) return;
    isRunned.current = true;

    async function createSession() {

      localStorage.clear();

      if (params.get("i") == null) {

        setLoading(false);
        setModalShow(false);
        setShow(true);
        setShowStatus(500);
        setShowMessage("Error al obtener el cpv")

      } else {

        const objCpv = {
          curpValidate: params.get("i"),
        };

        const response = await generarReporteSocioeconomicoB_Jumio(objCpv);

        if (response.status === 200) {


          const cardSvgPStr =
            "data:image/png;base64," + response.cardSvgP + "";

          const logoDPRStr =
            "data:image/png;base64," + response.logoDPR + "";

          const check_deepBlueStr =
            "data:image/png;base64," + response.check_deepBlue + "";

          const cardSvgBlackStr =
            "data:image/png;base64," + response.cardSvgBlack + "";

          const qrStr =
            "data:image/png;base64," + response.qr + "";

          setLogoDPR(logoDPRStr);
          setCardSvgP(cardSvgPStr);
          setCheck_deepBlue(check_deepBlueStr);
          setCardSvgBlack(cardSvgBlackStr);
          setQr(qrStr);

          setCpv(response.cpv);
          setVigencia(response.vigencia);
          setUsuarioNivelSocioeconomico(response.nivelSocioEconomico);
          setUsuarioMontoIngreso(response.montoIngreso);
          setNarrativa(response.narrativa);


          const telefonoCeluarStr =
            "data:image/png;base64," + response.telefonoCeluar + "";
          setTelefonoCeluar(telefonoCeluarStr);

          const televisionStr =
            "data:image/png;base64," + response.television + "";

          setTelevision(televisionStr);

          const internetMovilStr =
            "data:image/png;base64," + response.internetMovil + "";
          setInternetMovil(internetMovilStr);

          const motocicletaStr =
            "data:image/png;base64," + response.motocicleta + "";
          setMotocicleta(motocicletaStr);


          const internetFijoStr =
            "data:image/png;base64," + response.internetFijo + "";
          setInternetFijo(internetFijoStr);


          const tabletaElectronicaStr =
            "data:image/png;base64," + response.tabletaElectronica + "";
          setTabletaElectronica(tabletaElectronicaStr);

          const computadoraStr =
            "data:image/png;base64," + response.computadora + "";
          setComputadora(computadoraStr);


          const vehiculoStr =
            "data:image/png;base64," + response.vehiculo + "";
          setVehiculo(vehiculoStr);


          const telefonoInteligenteStr =
            "data:image/png;base64," + response.telefonoInteligente + "";
          setTelefonoInteligente(telefonoInteligenteStr);


          const viviendaPStr =
            "data:image/png;base64," + response.viviendaP + "";
          setViviendaP(viviendaPStr);


          const estructuraFamiliarGraficaStr =
            "data:image/png;base64," + response.estructuraFamiliarGrafica + "";
          setUsuarioEstructuraFamiliarGrafica(estructuraFamiliarGraficaStr);


          const patrimonioDeclaradoGraficaStr =
            "data:image/png;base64," + response.patrimonioDeclaradoGrafica + "";
          setUsuarioPatrimonioDeclaradoGrafica(patrimonioDeclaradoGraficaStr);


          const sonificacionViviendaGraficaStr =
            "data:image/png;base64," + response.sonificacionViviendaGrafica + "";
          setUsuarioSonificacionViviendaGrafica(sonificacionViviendaGraficaStr);

          const graficaStr =
            "data:image/png;base64," + response.grafica + "";
          setUsuarioGrafica(graficaStr);

          setEstructuraFamiliar(response.estructuraFamiliar);
          setPatrimonioDeclarado(response.patrimonioDeclarado);
          setSonificacionVivienda(response.sonificacionVivienda);
          if (response.tendencia === "") {
            setTendencia("<button type='button' class='btn green trend'>TENDENCIA &nbsp; A   CONSISTENTE</button>");
          } else {
            setTendencia(response.tendencia);
          }

          setUsuarioFooter(response.fecha);

          setIngresoG(response.ingresoG);
          setEducacionG(response.educacionG);
          setDigitalizacionG(response.digitalizacionG);
          setViviendaG(response.viviendaG);
          setUbicacionG(response.ubicacionG);
          setIngresoGrafica(response.ingresoGrafica);


          for (let i = 0; i < valorCicloAreas; i++) {
            if (i < response.ingresoGrafica) {
              ingresoArr.push(<span className="mark"></span>)
            } else {
              ingresoArr.push(<span></span>)
            }
          }



          for (let i = 0; i < valorCicloAreas; i++) {
            if (i < response.educacionGrafica) {
              educacionArr.push(<span className="mark"></span>)
            } else {
              educacionArr.push(<span></span>)
            }
          }

          for (let i = 0; i < valorCicloAreas; i++) {
            if (i < response.digitalGrafica) {
              digitalizacionGArr.push(<span className="mark"></span>)
            } else {
              digitalizacionGArr.push(<span></span>)
            }
          }

          for (let i = 0; i < valorCicloAreas; i++) {
            if (i < response.viviendaGrafica) {
              viviendaGArr.push(<span className="mark"></span>)
            } else {
              viviendaGArr.push(<span></span>)
            }
          }


          for (let i = 0; i < valorCicloAreas; i++) {
            if (i < response.ubicacionGrafica) {
              ubicacionGArr.push(<span className="mark"></span>)
            } else {
              ubicacionGArr.push(<span></span>)
            }
          }

          await generarImagenReporte();

          handlePrint();

        } else {

          setLoading(false);
          setShow(true);
          setShowStatus(response.status);
          setShowMessage(response.message);

        }

      }

    }

    createSession();

  }, []);



  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    print: async () => {
      const doc = new jsPDF();
      doc.html(componentRef.current, {
        html2canvas: {
          removeContainer: true,
          scale: 0.19,
        },
        margin: 5,
        x: -1,
        async callback(doc) {
          await doc.save('Examen SocioEconomico_' + cpv + '_' + formattedDate);
        },
      });
    },

  });

  return (
    <>
      <Modal show={show} onHide={handleClose} animation={false} centered>
        <Modal.Body className='backGroudModal'>
          <div className='msjTitleModalDiv'>Error {showStatus}</div>
          <div className='msjErrorModal'>{showMessage}</div>
        </Modal.Body>
        <Modal.Footer>
          <button className='button_P2' onClick={handleClose}>
            <span className='txtButton_P2'>Regresar</span>
          </button>
        </Modal.Footer>
      </Modal>

      <div className="w-100  justify-content-center" style={{ display: "flex", width: "965px", border: "none" }}>
        <div
          className=" animate__animated animate__fadeIn"
          ref={componentRef}
          style={{ display: "block", width: "1070px", border: "none" }}
        >
          <div className="relativeCSS">
            <style type="text/css" media="print">
              {
                "@page {  size: A4;  }"
              }
            </style>

            {/* hoja 1 */}
            <br />
            <div className="container-fluid">
              <section className="row">
                <div className="col-6">
                  <article className="identify-card ">
                    <aside className="account-detail gray">
                      <section className="detail-image">
                        <img src={logoDPR} alt="" />
                      </section>
                      <div className="detail-background">
                        <img src={cardSvgP} alt="" width={'65%'} height={'auto'} />
                      </div>
                    </aside>
                    <article className="middle-section">
                      <title className="title">
                        <div className="left">IDe</div>
                        <div className="right">
                          <strong>ERC Financiero</strong>
                          <br />
                          <span>Credencial Verificada</span>
                        </div>
                      </title>
                      <section className="info-section ">
                        <div className="subtitle">
                          <span>PROCESO &nbsp; DE CERTIFICACIÓN</span>
                          <h2>Socioeconómico</h2>
                          <h4>Módulo A</h4>
                        </div>
                        <hr className="division" />
                        <ul className="p-0">
                          <li>
                            <img src={check_deepBlue} alt="checkBlue" />
                            <span>AUTENTICACIÓN &nbsp; DE &nbsp; IDENTIDAD</span>
                          </li>
                          <li>
                            <img src={check_deepBlue} alt="checkBlue" />
                            <span>INFORMACIÓN &nbsp; REQUERIDA</span>
                          </li>
                          <li>
                            <img src={check_deepBlue} alt="checkBlue" />
                            <span>REFERENCIAS &nbsp; PERSONALES</span>
                          </li>
                        </ul>
                        <div className="expires">
                          <span className="text-lg">Vence&nbsp;: {vigencia}</span>
                        </div>
                      </section>
                    </article>
                    <article className="right-section ">
                      <div className="detail-finance identity">
                        <img src={cardSvgBlack} alt="" className="Card__img--rigth" />
                      </div>
                      <section className="qr-code">
                        <img className="qrSize" src={qr} alt="" />
                        <span className="cpv__text pr-4">CPV&nbsp;:{cpv}</span>
                      </section>
                      <section className="verify">
                        <img src={cardSvgP} alt="" className="verifyImg__new--sazing" />
                      </section>
                    </article>
                  </article>


                  <div className="titleCard">Verificación &nbsp; de &nbsp; autenticidad</div>
                  <div className="card verify-note">
                    <p className="f12"> El resultado obtenido  <strong> no es válido </strong> si la fecha en la parte superior izquierda de este
                      <strong> Reporte </strong> se encuentra <strong> vencida </strong> . Para &nbsp; comprobar su autenticidad escanee &nbsp; el código QR o ingrese directamente el código
                      <strong> CPV </strong> en <strong> www.midpr.net/verificar </strong> .
                    </p>
                  </div>
                  <small className="footer-note">
                    *Notifique si este Reporte es falso al +52 5571605526 y/o en www.midpr.net
                  </small>
                </div>
                <div className="col-6">
                  <h4 className="text-center ">Estudio Socioeconómico</h4>

                  <p className="f12">
                    Este <strong>&nbsp; Reporte </strong>
                    da constancia de la calificación resultante de la aplicación de manera
                    <strong> completa y concluyente </strong>
                    de esta Evaluación &nbsp; Remota Confiable (&nbsp; ERC &nbsp;) realizada por el
                    <strong> Aplicante </strong>
                    , obteniendo los siguientes resultados:
                  </p>

                  <div className="titleCard">Resultado &nbsp; obtenido</div>

                  <article className="card result">
                    <section className="graph-half-circle ">
                      <img src={usuarioGrafica} alt="" className="position-relative" />
                      <span className="percent-graph SocioEconomico__percents">{usuarioNivelSocioeconomico}</span>
                    </section>
                    <div className="d-flex justify-content-center  align-items-center mt-3">
                      <button type="button" className="btn gray">NIVEL  &nbsp; SOCIOECONÓMICO</button>
                    </div>
                  </article>

                  <small className="footer-note ">
                    *La interpretación de este resultado obtenido es responsabilidad exclusiva de quien lo recibe.
                  </small>
                </div>
              </section>
            </div>

            <div className="container-fluid">
              <div className="row">
                <div className="col-6 ">

                  <div className="titleCard">ECONOMÍA &nbsp; DIGITAL</div>
                  <section className="card digital-data  container-fluid px-4">
                    <div className="row">
                      <table >
                        <tbody >
                          <tr>
                            <td>
                              <img src={telefonoCeluar} alt="" />
                              <span>&nbsp;Teléfono celular</span>
                            </td>
                            <td>
                              <img src={internetMovil} alt="" />
                              <span>&nbsp;Internet móvil</span>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <img src={television} alt="" />
                              <span>&nbsp;Televisión</span>
                            </td>
                            <td>
                              <img src={motocicleta} alt="" />
                              <span>&nbsp;Motocicleta propia</span>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <img src={internetFijo} alt="" />
                              <span>&nbsp;Internet fijo</span>
                            </td>
                            <td>
                              <img src={tabletaElectronica} alt="" />
                              <span>&nbsp;Tableta electrónica</span>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <img src={computadora} alt="" />
                              <span>&nbsp;Computadora</span>
                            </td>
                            <td>
                              <img src={vehiculo} alt="" />
                              <span>&nbsp;Vehículo particular</span>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <img src={telefonoInteligente} alt="" />
                              <span>&nbsp;Teléfono inteligente</span>
                            </td>
                            <td>
                              <img src={viviendaP} alt="" />
                              <span>&nbsp;Vivienda propia</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </section>
                  <table className="three-graphics">
                    <tbody>
                      <tr>
                        <td>
                          <div className="graph-half-circle position-relative">
                            <img src={usuarioEstructuraFamiliarGrafica} alt="" className="" />
                            <span className="percent-graph SocioEconomico__percents--trheeGraph">{estructuraFamiliar}</span>
                          </div>
                          <span className="label-graph">Estructura <br /> Familiar</span>
                        </td>
                        <td>
                          <div className="graph-half-circle position-relative">
                            <img src={usuarioPatrimonioDeclaradoGrafica} alt="" />
                            <span className="percent-graph SocioEconomico__percents--trheeGraph">{patrimonioDeclarado}</span>
                          </div>
                          <span className="label-graph">Patrimonio <br /> declarado</span>
                        </td>
                        <td>
                          <div className="graph-half-circle position-relative">
                            <img src={usuarioSonificacionViviendaGrafica} alt="" />
                            <span className="percent-graph SocioEconomico__percents--trheeGraph">{sonificacionVivienda}</span>
                          </div>
                          <span className="label-graph">Zonificación <br /> de vivienda
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div className=" d-flex justify-content-center align-items-center">
                    {parse(tendencia)}
                  </div>

                  <small className="footer-note">*Consulte definiciones de estas métricas en www.midpr.net/resultados</small>
                  <p className="f12">
                    Esta <strong>&nbsp; ERC &nbsp;</strong>
                    fue realizada de manera automatizada a través de un dispositivo digital propiedad del
                    <strong> Aplicante </strong>
                    . Durante el proceso, se registraron una serie de datos de carácter personal que fueron analizados&nbsp;, validados y/o verificados que permitieron, posterior al análisis de la información, la obtención del dictamen presentado con respecto a la consistencia o inconsistencia de estos de manera integral.

                  </p>
                </div>
                <div className="col-6 ">
                  <div className="titleCard">ÁREAS  &nbsp; EVALUADAS</div>
                  <div className="card evaluated-areas">
                    <ul className="SocioEconomico__wordSpacing">
                      <li>
                        <div className="single">
                          <div className="title">Ingreso</div>
                          <div className="graph-line">
                            <div className="content-graph">
                              {ingresoArr}
                            </div>
                            <div className="text-graph">
                              {ingresoG}
                            </div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="single">
                          <div className="title">Educación</div>
                          <div className="graph-line">
                            <div className="content-graph">
                              {educacionArr}
                            </div>
                            <div className="text-graph">
                              {educacionG}
                            </div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="single">
                          <div className="title">Digitalización</div>
                          <div className="graph-line">
                            <div className="content-graph">
                              {digitalizacionGArr}
                            </div>
                            <div className="text-graph">
                              {digitalizacionG}
                            </div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="single">
                          <div className="title">Vivienda</div>
                          <div className="graph-line">
                            <div className="content-graph">
                              {viviendaGArr}
                            </div>
                            <div className="text-graph">
                              {viviendaG}
                            </div>
                          </div>
                        </div>

                      </li>
                      <li>

                        <div className="single">
                          <div className="title">Ubicación</div>
                          <div className="graph-line">
                            <div className="content-graph">
                              {ubicacionGArr}
                            </div>
                            <div className="text-graph">
                              {ubicacionG}
                            </div>
                          </div>
                        </div>

                      </li>
                    </ul>
                  </div>


                  <small className="footer-note">*Consulte al reverso de este Reporte las imágenes recabadas.</small>
                  <div className="d-flex justify-content-center">
                    <button type="button" className="btn gray references w-100">{usuarioReferencias} <span className="label-msg">Referencias personales verificadas</span></button>
                  </div>

                  <div className="titleCard">INGRESO &nbsp;FAMILIAR</div>
                  <section className="card family-income">
                    <p className="f11">Con los datos obtenidos se establece que el ingreso mensual familiar en MXN es de: </p>
                    <h6><strong> {usuarioMontoIngreso} </strong></h6>
                  </section>
                </div>
              </div>
            </div>

            <section className="note-gray note-emit">
              <p className="Footer__font--weigth">
                Se emite el presente Reporte el {parse(usuarioFooter)} en calidad de INFORMACIÓN &nbsp; CONFIDENCIAL
              </p>

            </section>
            <small className="footer-note">*Consulte al reverso de este Reporte DPR &nbsp; nuestra Política de Privacidad y/o en www.midpr.net/privacidad</small>
            <div className="titleCard">AVISO &nbsp; LEGAL</div>
            <div class="card legal-advise">
              <p className="f12">La <strong>&nbsp; Calificación &nbsp;</strong> realizada de manera remota por el <strong>Aplicante</strong>, a la que hace referencia este <strong>Reporte</strong>, fue realizada a solicitud directa del <strong>Destinatario</strong>. Antes y durante la <strong>&nbsp;Calificación&nbsp;</strong>, fue autenticada la identidad del <strong>Aplicante</strong> y se registraron una serie de datos e información de carácter personal con su autorización expresa, lo cual permitió emitir una Evaluación &nbsp; Remota Confiable (&nbsp; ERC &nbsp;). El &nbsp; <strong>Destinatario</strong> acepta que todos los datos contenidos en el presente <strong>Reporte</strong> son confidenciales y de interés exclusivo y privado, que es compartida únicamente con el propósito que ha sido previamente informado por el <strong>Destinatario</strong> y que ha autorizado por el <strong>Aplicante</strong> previo a la aplicación de la &nbsp; <strong>Calificación</strong>&nbsp;. &nbsp;El <strong>Aplicante</strong> y/o el <strong>Destinatario</strong> de este Reporte aceptan de conformidad la responsabilidad sobre cualquier uso indebido o ilegal de este documento y su contenido, así como todos los términos y condiciones descritos al reverso. <strong>Una vez entregado este Reporte al Destinatario, el Fabricante se deslinda de toda responsabilidad &nbsp; sobre su interpretación, divulgación y uso</strong>.</p>
            </div>
            <p class="txt-center f12 mt-2"><strong>Business &nbsp; Prey SA de CV</strong> hace referencia que con número de registro <strong>DGSP&nbsp;/369-19/3919</strong>, está autorizada por la <strong>SSPC&nbsp;/DGSP &nbsp;</strong> para la aplicación de Pruebas y Evaluación de Control de Confianza de conformidad con los <strong>Lineamientos y Criterios Técnicos&nbsp;</strong> publicados en el Diario Oficial de la Federación (DOF) el <strong>28 de abril de 2020</strong>.</p>

            {/* hoja 2 */}

            <br />
            <br />
            <br />
            <br />
            <br />
            <br />

            <div className="Documetos__size--padding">

            </div>

            <div className="div-vertical">
              <div className="div-horizontal" id="div1">
                <div className="titleCard">OBSERVACIONES</div>
                <div className="card evaluated-areas tipo-d borderCard">
                  <div className="f12 Word__Spacing font__new">
                    {parse(narrativa)}
                  </div>
                </div>

                <div className="cardLeft mt-5">
                  <div className="subTitleCardTwo">
                    <b>Business &nbsp; Prey SA de CV (BP)</b>, Fabricante exclusivo en la
                    República Mexicana para DPR, con número de registro
                    autorización DGSP/369-19/3919 expedido por la Dirección
                    General de Seguridad Privada (DGSP) de la Secretaría de
                    Seguridad y Protección Ciudadana (SSPC)&nbsp; para la aplicación
                    de pruebas de evaluación de control de confianza en
                    términos de los Lineamientos y Criterios Técnicos que
                    deberán cumplir las Empresas de Seguridad Privada bajo la
                    Modalidad VI, previsto en el artículo 15 de la Ley Federal
                    de Seguridad Privada (LFSP), publicados con fecha de 28 de
                    abril de 2020, en el Diario Oficial de la Federación (DOF)
                    y en cumplimiento con lo dispuesto por los artículos 1, 3,
                    6, 7, 8, 12 y 14 de la Ley Federal de Protección de Datos
                    Personales en Posesión de los Particulares emite el
                    resultado de la presente Evaluación Remota Confiable
                    (ERC).
                  </div>

                  <div className="subTitleCardTwo">
                    <b>Aplicación de la Evaluación ERC</b> La presente ERC fue
                    acotada a una Área de Interés específica mediante un
                    proceso remoto que el Aplicante aceptó de manera expresa y
                    totalmente voluntaria someterse a la evaluación, con la
                    finalidad de ser calificado en diversas Temáticas con lo
                    que se estimó el Resultado Obtenido, conforme a la
                    metodología y marcos de referencia establecidos por DPR
                    para tal efecto. Para la realización de la ERC, el
                    Aplicante utiliza dispositivos electrónicos de su
                    propiedad, fuera del control del Fabricante, por lo que se
                    aplican avanzados métodos de validación y verificación de
                    datos para asegurar su veracidad y autenticidad.
                  </div>

                  <div className="subTitleCardTwo">
                    <b>Declaración de Veracidad</b> Esta evaluación ERC &nbsp; puede o no
                    formar parte de un proceso de certificación que incluye
                    una Prueba DPR. Al presentar esta ERC, el Aplicante acepta
                    y se somete a una declaración bajo protesta de decir
                    verdad de proporcionar información fidedigna. La veracidad
                    de la misma puede ser comprobada durante o posteriormente.
                  </div>

                  <div className="subTitleCardTwo mt-5">
                    <b>Proceso de Calificación</b> La ERC incluye un conjunto de
                    Áreas Evaluadas que incluyen Temas de Interés que son
                    requisitados para obtener un Resultado y un Dictamen. La
                    información que se recaba y se procesa durante la
                    evaluación se describen en este Reporte y corresponden a
                    una dimensión particular de datos adquiridos del
                    Aplicante.
                  </div>

                  <div className="subTitleCardTwo">
                    <b>Interpretación de los Resultados</b> Esta ERC incluye los
                    diversas Temas de Interés para obtener un Resultado
                    Obtenido y el Dictamen de veracidad o congruencia, que son
                    exclusivamente un parámetro medido en porcentaje y/o una
                    valoración cualitativa correspondientemente, por lo que no
                    existe un valor o magnitud específica que sea aprobatoria
                    o no aprobatoria. Es responsabilidad exclusiva del
                    Destinatario establecer el umbral mínimo o máximo
                    esperado, para la determinación de la aceptación del
                    Aplicante o para la permanencia de acuerdo a los
                    Resultados Obtenidos.
                  </div>

                  <div className="subTitleCardTwo">
                    <b>Emisión del Certificado</b> Al culminar de manera concluyente
                    esta ERC, el resultado se procesa en un periodo máximo de
                    24 horas. El resultado, datos y dictamen descrito en este
                    Reporte, es sellado digitalmente mediante un Certificado
                    Personal Verificable (CPV) de forma numérica o en QR que
                    puede ser utilizado para confirmar la vigencia y
                    autenticidad del mismo en la página
                    www.midpr.net/verificar. Este Reporte deberá ser
                    considerado como falso, si la consulta no resulta en la
                    leyenda de “Verificado”.
                  </div>
                </div>
                <div className="mt-5">
                  <div className="subTitleCardTwo">
                    <b>Privacidad de Datos Personales</b> Para efectos del
                    cumplimiento del artículo 9 de la Ley Federal de
                    Protección de Datos Personales en Posesión de los
                    Particulares (LFPDPPP) ,&nbsp; el Aplicante de la ERC manifiesta
                    expresamente que otorgó su consentimiento para el
                    tratamiento de sus datos personales sensibles, durante los
                    procedimientos de recopilación y procesamiento, aceptando
                    los términos y condiciones para tales efectos.
                  </div>

                  <div className="subTitleCardTwo">
                    <b>Uso de las Marcas</b> DPR y las marcas asociadas son marcas
                    registradas, protegida por los artículos 88 y 142 de la
                    Ley de Propiedad Industrial (LPI), así como el convenio de
                    París para efectos internacionales. El consumo o
                    adquisición de cualquiera de los servicios vinculados a
                    DPR y/o proporcionados por el Fabricante, no confieren al
                    Aplicante y/o al Destinatario el derecho de uso de las
                    marcas de DPR en ningún contexto y/o formato, ya que al
                    hacerlo podría resultar en actividad fraudulenta y ser
                    clasificado como un delito. La marca, propiedad
                    intelectual o cualquier otro tipo de secreto industrial
                    contenido en este Reporte, no autoriza el uso, explotación
                    comercial, venta, reproducción o distribución de dicha
                    información.
                  </div>

                  <div className="subTitleCardTwo">
                    <b>Uso de Información por Terceros</b> Al realizar la ERC, el
                    Aplicante autoriza la entrega del resultado obtenido al
                    Destinatario para el uso particular que ambos hayan
                    acordado. Para el caso exclusivo de Elementos de Seguridad
                    Privada, la entrega de este Reporte a la DGSP, se hará
                    conforme a lo previsto en el artículo 9 de los citados
                    Lineamientos y Criterios Técnicos.
                  </div>

                  <div className="subTitleCardTwo">
                    <b>
                      En DPR estamos a favor de la confianza profesional, la
                      honestidad y transparencia, la privacidad de datos
                      personales, la equidad de género, la inclusión financiera
                      y digital, la igualdad de oportunidades y la no
                      discriminación.
                    </b>
                  </div>

                  <div className="card evaluated-areas tipo-d borderCard mt-5">
                    <div className="titleContainerSinBorder">
                      TEMAS DE INTERÉS
                    </div>
                    <div className="subTitleCardTwo">
                      <ul className="espacio-ul-left">
                        <li>
                          <strong>Núcleo familiar:</strong> Estado civil (jefe de familia), ocupación económica
                          (jefe de familia), dependientes económicos (jefe de familia), habitantes en la vivienda,
                          ubicación de la vivienda, ingreso combinado (hogar).
                        </li>
                        <li>
                          <strong>Nivel socioeconómico:</strong> Nivel educativo (jefe de familia), discapacidad (jefe de familia),
                          descripción de la vivienda, vehículos propios, miembros económicamente activos (hogar).
                        </li>
                        <li>
                          <strong>Grado de digitalización:</strong> Dispositivos electrónicos, acceso a internet, servicios
                          de <i>&nbsp; Streaming &nbsp;</i>, uso de aplicativos.
                        </li>
                        <li>
                          <strong>Referencias personales:</strong> Número de Identidad Nacional (verificado), número célular (validado),
                          correo electrónico (validado), tipo de relación (personal),
                          domicilio particular (validado).
                        </li>
                      </ul>
                    </div>
                  </div>
                  <br />
                  <br />
                  <div className="note-gray">
                    <p>
                      <strong>Business Prey SA de CV</strong> con domicilio en
                      Alfonso Reyes 216 Dep L003, Col. Hipódromo, C.P. 06100 Alcaldía Cuauhtémoc, CDMX, México, CDMX, es Fabricante exclusivo de
                      DPR. Para mayor información llame al +52 5571605526 o
                      visite el sitio <strong>www.midpr.net</strong>.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SocioEconomicoB_Jumio